<div class="relative">
  <button (click)="onClose()" class="outline-0 absolute top-2 right-2 z-1 px-1 py-1 rounded-full bg-white cursor-pointer">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.38632 4.38654C4.67921 4.09365 5.15409 4.09365 5.44698 4.38654L9.99997 8.93956L14.553 4.38656C14.8459 4.09367 15.3208 4.09367 15.6136 4.38656C15.9065 4.67946 15.9065 5.15433 15.6136 5.44722L11.0606 10.0002L15.6136 14.5532C15.9065 14.8461 15.9065 15.321 15.6136 15.6139C15.3207 15.9068 14.8459 15.9068 14.553 15.6139L9.99997 11.0609L5.44696 15.6139C5.15406 15.9068 4.67919 15.9068 4.38629 15.6139C4.0934 15.321 4.0934 14.8461 4.3863 14.5532L8.93931 10.0002L4.38631 5.4472C4.09342 5.1543 4.09342 4.67943 4.38632 4.38654Z" fill="#FF0650"/>
    </svg>
  </button>
  <sens-subscription/>
</div>



